import {Position} from "../../store/nodes";

export const _scale = 2;
export const scaled = (pos: Position) => ({x: pos.x * _scale, y: pos.y * _scale});